import axios from 'axios';
import { settings } from '../config';
import packageJson from '../../../package.json';

export async function login() {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${encodeURIComponent(initData)}`,
    },
  };

  try {
    const url = `${settings.url}users/auth?version=${packageJson.version}`;

    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

// export async function getBoxes() {
//   const config = {
//     headers: {
//       Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
//     },
//   };
//   try {
//     const url = `${settings.url}boxes`;
//     const response = await axios.get(url, config);
//     return response.data;
//   } catch (e) {
//     console.log('ОШИБКА', e);
//   }
// }
